import { render } from "./DevolucionCompra.vue?vue&type=template&id=e61902de"
import script from "./DevolucionCompra.vue?vue&type=script&lang=js"
export * from "./DevolucionCompra.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__